import React from 'react';
import { UhLogoWithType } from 'components/uh-x-clue/HeroIcons';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './BrandMarks.module.css';

export { UhLogoWithType };

export const LesMillsLogoWithType = ({
  className,
  alt,
}: {
  className?: string;
  alt?: string;
}) => (
  <img
    className={
      className
        ? `${styles.lesMillsLogoImg} ${className}`
        : styles.lesMillsLogoImg
    }
    src={getCompressedAssetUrl('/web_v2/uh-x-les-mills/hero/les-mills-logo.svg')}
    alt={alt || 'Les Mills'}
  />
);
